import { render, staticRenderFns } from "./Poweredby.vue?vue&type=template&id=3b64426b&"
import script from "./Poweredby.vue?vue&type=script&lang=js&"
export * from "./Poweredby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports